import { useEffect } from 'react';
import { SetFieldValue } from 'react-hook-form';

import { DynamicQrCodeData } from '~/types/qrCode';

export default function usePrefillQrCodeData({
  isQRCodeData,
  qrCodeData,
  setValue,
}: {
  qrCodeData: DynamicQrCodeData;
  isQRCodeData: boolean;
  setValue: SetFieldValue<any>;
}) {
  useEffect(() => {
    if (isQRCodeData) {
      if (qrCodeData.name) {
        setValue('qrCodeName', qrCodeData.name);
      }

      setValue('passwordProtection.isPasswordProtected', qrCodeData.isPasswordProtected ?? false);

      setValue('settings.qrCodeUrl', qrCodeData?.uri);
      setValue('settings.isAutoGeneratedUrl', qrCodeData.isAutogeneratedUrl);
      setValue('settings.isScanLimitsEnabled', !!qrCodeData.scanLimit);

      if (qrCodeData.scanLimit) {
        setValue('settings.scanLimit', qrCodeData.scanLimit);
      }

      if (typeof qrCodeData.folder?.id === 'number') {
        setValue('qrCodeFolder', qrCodeData.folder.id);
      }
    }
  }, [isQRCodeData]);
}
